<template>
  <div class="my-attendance-table">
    <b-table
      ref="ref-table-monitoring-viatic"
      sticky-header="50vh"
      small
      class="position-relative bord"
      table-class="text-nowrap"
      primary-key="date"
      :fields="fields"
      :items="attendances"
    >
      <template #cell(day)="data">
        <div>
          <div>{{ $t(data.item.day) }}</div>
          <b-badge variant="light-warning" v-if="data.item.is_late">
            {{ $t("LATE") }}
          </b-badge>
        </div>
      </template>
      <template #cell(date)="data">
        <div>
          <div>{{ data.item.date | myGlobal }}</div>
        </div>
      </template>
      <template #cell(start_hour)="data">
        <div>
          <!-- <b-badge v-if="data.item.holidays" variant="light-warning">
            {{ $t("HOLIDAY") }}</b-badge
          >
          <b-badge
            v-if="!data.item.holidays && !data.item.start_hour"
            variant="light-danger"
          >
            {{ $t("UNMARKED") }}
          </b-badge> -->
          <b-badge :variant="variantStatus(data.item)">
            {{ textStatus(data.item, data.item.start_hour) }}</b-badge
          >
        </div>
      </template>
      <template #cell(start_break)="data">
        <div>
          <b-badge :variant="variantStatus(data.item)">
            {{ textStatus(data.item, data.item.start_break) }}</b-badge
          >
        </div>
      </template>
      <template #cell(end_break)="data">
        <div>
          <b-badge :variant="variantStatus(data.item)">
            {{ textStatus(data.item, data.item.end_break) }}</b-badge
          >
        </div>
      </template>
      <template #cell(end_hour)="data">
        <div>
          <b-badge :variant="variantStatus(data.item)">
            {{ textStatus(data.item, data.item.end_hour) }}</b-badge
          >
        </div>
      </template>
      <template #cell(holidays)="data">
        <div>{{ data.item.holidays ? 0 : 0 }} Hrs</div>
      </template>
      <template #cell(total)="data">
        <div>
          {{
            (data.item.status == 1 || data.item.status == 4) &&
            !data.item.holidays
              ? getTotalHours(data.item.start_hour, data.item.end_hour)
              : 0
          }}
          Hrs
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    attendances: {
      type: Array,
      required: true,
    },
  },
  computed: {
    fields() {
      return [
        {
          // [0]
          key: "day",
          label: this.$t("day"),
          visible: true,
        },
        {
          // [1]
          key: "date",
          label: this.$t("date"),
          visible: true,
        },
        {
          // [2]
          key: "start_hour",
          label: this.$t("start hour"),
          visible: false,
        },
        {
          // [3]
          key: "start_break",
          label: this.$t("start break"),
          visible: true,
        },
        {
          // [3]
          key: "end_break",
          label: this.$t("end break"),
          visible: true,
        },
        {
          // [3]
          key: "end_hour",
          label: this.$t("end hour"),
          visible: true,
        },
        {
          // [3]
          key: "holidays",
          label: this.$t("holiday"),
          visible: true,
        },
        {
          // [3]
          key: "total",
          label: "total",
          visible: true,
        },
      ];
    },
  },
  data() {
    return {};
  },

  methods: {
    getTotalHours(start, end) {
      if (start && end) {
        const horaInicio = new Date(`1970-01-01T${start}`);
        const horaFin = new Date(`1970-01-01T${end}`);
        const diferenciaEnMilisegundos = horaFin - horaInicio;
        return Math.floor(diferenciaEnMilisegundos / 3600000);
      }

      if (start && !end) {
        const horaActual = new Date();
        const horaRestar = new Date(`2023-01-01T${start}`);
        const horaActualMs = horaActual.getTime();
        const horaRestarMs = horaRestar.getTime();
        const diferenciaEnMilisegundos = horaActualMs - horaRestarMs;
        return Math.floor(diferenciaEnMilisegundos / 3600000);
      }

      return 0;
    },

    variantStatus(day) {
      if (!day.past_date) {
        return "light-secondary";
      }
      if (day.holidays) {
        return "light-info";
      }

      if(day.status == 3){
        return "light-primary";
      }

      if (!day.start_hour) {
        return "light-danger";
      }

      switch (day.status) {
        case 1:
          return "light-success";
        case 2:
          return "light-secondary";
        case 3:
          return "light-primary";
        case 4:
          return "light-success";
      }
    },

    textStatus(day, value) {
      if (!day.past_date) {
        return this.$t("PENDING");
      }
      if (day.holidays) {
        return this.$t("HOLIDAYS");
      }

      if(day.status == 3){
        return this.$t("REMOTE");
      }
      
      if (!day.start_hour) {
        return this.$t("UNMARKED");
      }
      switch (day.status) {
        case 1:
          return value;
        case 2:
          return this.$t("NOT WORKING");
        case 3:
          return this.$t("REMOTE");
        case 4:
          return value;
      }
    },
  },
};
</script>

<style lang="scss">
.my-attendance-table {
  font-family: "Roboto";
  table {
    background-color: none !important;
  }

  thead tr {
    // height: 40px !important;

    .table-b-table-default {
      //   background-color: red;
      //   padding-top: 12px;
      text-align: center;
    }
  }

  tbody tr {
    height: 55px !important;

    td {
      text-align: center;
    }
  }
}
</style>